import layout from '../view/layout'

const router = {
  name: 'order',
  path: 'order',
  component: layout,
  meta: {
    title: '订单管理',
    ico: 'el-icon-s-order',
    authkey: 'order'
  },
  children: [
    {
      name: 'order_index',
      path: 'index',
      component: () => import('../view/order/index'),
      meta: {
        route_name: 'order_index',
        title: '订单列表',
        ico: '',
        isShow: true,
        authkey: 'order_trade'
      }
    },
    {
      name: 'order_detail',
      path: 'detail/:id',
      component: () => import('../view/order/detail'),
      meta: {
        title: '订单详情',
        ico: '',
        isShow: false,
        authkey: ''
      }
    },
    {
      name: 'order_refund_detail',
      path: 'refund/detail/:id',
      component: () => import('../view/order/refund_detail'),
      meta: {
        title: '退款详情',
        ico: '',
        isShow: false,
        authkey: ''
      }
    },
    {
      name: 'trade_index',
      path: 'trade',
      component: () => import('../view/order/trade'),
      meta: {
        route_name: 'trade_index',
        title: '业绩发放',
        ico: '',
        isShow: true,
        authkey: 'trade_index'
      }
    },
    {
      name: 'order_withdraw',
      path: 'withdraw',
      component: () => import('../view/order/withdraw'),
      meta: {
        route_name: 'order_withdraw',
        title: '业绩发放记录',
        ico: '',
        isShow: true,
        authkey: 'order_withdraw'
      }
    },
    {
      name: 'order_statics',
      path: 'statics',
      component: () => import('../view/order/rechage.vue'),
      meta: {
        route_name: 'order_statics',
        title: '充值统计',
        ico: '',
        isShow: true,
        authkey: 'order_statics'
      }
    }
  ]
}

export default router
